import { useLocaleContext } from '../../i18n';
import BaseSlider from './BaseSlider';

interface Props {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  zoneColor?: string;
}

export default function FtpSlider({ value, onChange, disabled, zoneColor }: Props) {
  const { locale } = useLocaleContext();

  return (
    <BaseSlider
      label={locale.settings.cyclist.ftp}
      value={value}
      onChange={onChange}
      min={50}
      max={600}
      step={1}
      unit="W"
      disabled={disabled}
      zoneColor={zoneColor}
    />
  );
}
